import React from 'react';
import '../App.css';

const Privacy = () => {
  return (
    <div className="" style={{ display: 'flex', alignItems: '', justifyContent: 'center', height: '100vh', overflow: 'auto', width: '100vw', background: '#a1a1a1', padding: '20px', marginBottom: '100px' }}>
      <div style={{ width: '100%', maxWidth: '800px', background: '#a1a1a1', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: '', justifyContent: 'start' }}>
        <h1 style={{ textAlign: 'center' }}>Privacy Policy</h1>
        <h3 style={{ textAlign: 'center' }}>Last updated: August 26th, 2025</h3>
        <br />  
        <p>This Privacy Policy outlines how ChessThread (“we,” “our,” “us”) collects, uses, and protects your information. [ChessThread.com] is a social media platform dedicated to sharing and interacting with other users and chess content, including user-generated games, commentary, and interaction. By using the platform, you agree to the terms of this policy.</p>








        1. Information We Collect<br />

We may collect and store the following data:<br />

- Account Data: Email address, username, and password (hashed)<br />
- User Activity: Uploaded games, comments, likes, reports, interactions, and more<br />
- Device Metadata: IP address, browser type, and general usage analytics<br />
- Payment Information: If premium features are added, payments are processed by Stripe. We do not store card details—only the necessary Stripe customer ID to verify subscriptions<br /><br />

2. How We Use Your Information<br />

We use your data to:<br />

- Create and manage your account<br />
- Display and host your submitted content<br />
- Communicate with you (e.g., notifications, updates)<br />
- Monitor and enforce community standards<br />
- Analyze platform performance and detect abuse<br />
- Maintain platform integrity<br /><br />



          
        3. Data Sharing<br />

We do not sell your information.<br />

We may share your data only with:<br />

- Stripe for processing payments<br />
- Secure infrastructure services for hosting, authentication, and storage<br />
- Moderators as needed to resolve user reports or enforce terms<br />
- Legal authorities, if required by law or valid legal request<br /><br />

All third-party services are bound by confidentiality and data protection obligations.<br /><br />

        4. Data Retention<br />

- Account and content data are stored as long as your account is active.<br />
- Upon account deletion, we may delete or anonymize some or all associated account data where technically feasible.<br />
- Certain residual data (e.g., backups or logs) may persist briefly for security and recovery purposes.<br /><br />

        5. User Rights<br />

You may:<br />

- Request access to your data<br />
- Request correction or deletion of your data<br />
- Delete your account directly through the app settings, or by contacting [info@chessthread.com](mailto:info@chessthread.com)<br /><br />

We respond to all verified requests within 30 days. Identity confirmation may be required.<br /><br />

        6. Data Security<br />

We use:<br />

- Encrypted HTTPS connections<br />
- Password hashing and secure authentication<br />
- Rate-limiting and abuse prevention mechanisms<br /><br />

While no system is impenetrable, we apply industry-standard practices to protect your data. <br /><br />

          
        7. Cookies and Tracking<br />

We use minimal cookies for:<br />

- Session authentication<br />
- Site preferences (e.g., theme)<br />
- Anonymous usage statistics (non-personally identifiable)<br /><br />


          
        8. Children's Privacy<br />

ChessThread is not intended for children under the age of 13. We do not knowingly collect or store data from anyone under this age. If such data is discovered, it will be deleted.<br /> <br />


        9. Changes to This Policy<br />

We may update this Privacy Policy from time to time. If significant changes are made, we will notify users via the platform or email. Continued use after updates constitutes acceptance.<br /> <br />
          
          
        10. Contact<br />

    For privacy-related questions or requests, contact:<br />Email: info@chessthread.com
    <br /><br />Use of ChessThread.com constitutes agreement with this Privacy Policy.








          
        
      </div>
    </div>
  );
};

export default Privacy;